var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"tw-text-center title-wizard"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{staticClass:"tw-text-center subtitle-wizard"},[_vm._v(_vm._s(_vm.subtitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }